export default __webpack_public_path__ + "static/media/shops-large.5c4385b3.svg";